/** Запись type=default из базы. Запасной набор, если /seo/public недоступен. */
export const SEO_DEFAULT = {
  id: 0,
  brand_id: 7,
  type: 'default',
  link: '',
  title: 'Eikosha - Автомобильный парфюм из Японии',
  h1: '',
  meta: 'Eikosha официальный сайт эксклюзивного поставщика JAPAN AUTOMOBILE PARFUME. Автомобильный парфюм.',
  request: 'Eikosha официальный сайт эксклюзивного поставщика JAPAN AUTOMOBILE PARFUME. Автомобильный парфюм.',
}
